export const findDay = (dayNum, language) => {
  switch (dayNum) {
    case 0:
      return language == "english" ? "Monday" : "الاثنين";
      break;
    case 1:
      return language == "english" ? "Tuesday" : "الثلاثاء";
      break;
    case 2:
      return language == "english" ? "Wednesday" : "الاربعاء";
      break;
    case 3:
      return language == "english" ? "Thursday" : "الخميس";
      break;
    case 4:
      return language == "english" ? "Friday" : "الجمعة";
      break;
    case 5:
      return language == "english" ? "Saturday" : "السبت";
      break;
    case 6:
      return language == "english" ? "Sunday" : "الاحد";
      break;

    default:
      break;
  }
};

export const findHighlightColor = indx => {
  switch (indx) {
    case 0:
      return "red";
      break;
    case 1:
      return "blue";
      break;
    case 2:
      return "green";
      break;
    case 3:
      return "orange";
      break;
    default:
      return "black";
      break;
  }
};

export const timeConvert = (time, language) => {
  // Check correct time format and split into components
  time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
    time
  ];
  const morning = language == "english" ? " AM" : " ص";
  const evening = language == "english" ? " PM" : " م";

  if (time.length > 1) {
    // If time format correct
    time = time.slice(1); // Remove full string match value
    time[5] = +time[0] < 12 ? morning : evening; // Set AM/PM
    time[0] = +time[0] % 12 || 12; // Adjust hours
  }
  time.splice(3, 1);
  return time.join(""); // return adjusted time or original string
};

export const convertTime12to24 = time12h => {
  const [time, modifier] = time12h.split(" ");

  let [hours, minutes] = time.split(":");

  if (hours === "12") {
    hours = "00";
  }

  if (modifier === "PM") {
    hours = parseInt(hours, 10) + 12;
  }

  return `${hours}:${minutes}`;
};
export const compareTime = (str1, str2) => {
  if (str1 === str2) {
    return 1;
  }
  var time1 = str1.split(":");
  var time2 = str2.split(":");

  if (parseInt(time1[0]) > parseInt(time2[0])) {
    return 1;
  } else if (
    parseInt(time1[0]) == parseInt(time2[0]) &&
    parseInt(time1[1]) > parseInt(time2[1])
  ) {
    return 1;
  } else {
    return -1;
  }
};
